import { NAVIGATE_TO } from "./constants";
import { NavigateToPayload, NavigateToAction } from "./types";

export const navigateTo = (payload: NavigateToPayload): NavigateToAction => ({
  type: NAVIGATE_TO,
  payload,
});
